import { ResponseTranslation } from '../../translations';

export interface ItemMaster {
  id: string;
  itemCode: string;
  inventoryTypeReference: string;
  itemDescription: ResponseTranslation;
  itemDisplayName: ResponseTranslation;
  itemLongDisplayName: ResponseTranslation;
  unitOfMeasure: number;
  itemCategoryCode: string;
  itemLowestSubCategoryCode: string;
  itemClassificationCode: string;
  certificationReferences?: string[];
  relationships?: ItemRelationship[];
  status: number;
  sgiCode: number;
  cisCode: number;
  baseYarnCode?: string;
  baseFabricCode?: string;
  baseGreigeCode?: string;
  fieldToDisplay?: string;
}

export interface ItemMasterGreigeSearchCommand {
  baseGreigeCode: string;
  itemMasterRelationships: ItemRelationship[];
}

export interface ItemMasterCodeBatchCommand {
  itemCodes: string[];
}

export interface ItemMasterFilter {
  itemCategoryReference?: string;
  itemCategoryCode?: string;
  itemLowestSubCategoryCode?: string;
  itemCode?: string;
  inventoryTypeReference?: string;
  description?: string;
  name?: string;
  baseYarnCode?: string;
  baseGreigeCode?: string;
}

export interface ItemRelationship {
  itemMasterCode: string;
  relationshipType: number;
  quantity?: number;
  unitOfMeasure?: number;
}

export enum ItemRelationshipType {
  Composition,
}

export enum Uom {
  pct = 7,
}

export interface Certification {
  id: string;
  name: string;
  includedCompositions: string[];
  allCompositions: boolean;
}

export interface ItemCategory {
  id: string;
  code: string;
  mongoDBCollection?: string;
  displayName: ResponseTranslation;
  name: ResponseTranslation;
  parentCode: string;
  level: number;
  selectable: boolean;
  isActive: boolean;
  description?: string;
}
